import {switchExpression} from 'screens/InsomniaSurvey/utils/switchExpression';

export const calculatedValues = [
  {
    name: 'gendered_noun',
    expression: switchExpression({
      switch: '{gender}',
      cases: {
        Male: 'man',
        Female: 'woman',
        _default: 'person',
      },
    }),
  },
  {
    name: 'gendered_noun_plural',
    expression: switchExpression({
      switch: '{gender}',
      cases: {
        Male: 'men',
        Female: 'women',
        _default: 'people',
      },
    }),
  },
  {
    name: 'gendered_noun_plural_capitalized',
    expression: switchExpression({
      switch: '{gender}',
      cases: {
        Male: 'Men',
        Female: 'Women',
        _default: 'People',
      },
    }),
  },
  {
    name: 'in_your_age_group',
    expression: switchExpression({
      switch: '{age}',
      cases: {
        '18-23': 'in your late teens or early 20s',
        '24-29': 'in your 20s',
        '30s': 'in your 30s',
        '40s': 'in your 40s',
        '50s': 'in your 50s',
        '60+': 'over 60',
        _default: '',
      },
    }),
  },
  {
    name: 'in_their_age_group',
    expression: switchExpression({
      switch: '{age}',
      cases: {
        '18-23': 'in their late teens or early 20s',
        '24-29': 'in their 20s',
        '30s': 'in their 30s',
        '40s': 'in their 40s',
        '50s': 'in their 50s',
        '60+': 'over 60',
        _default: '',
      },
    }),
  },
  {
    name: 'goal_phrase_gerund',
    expression: switchExpression({
      switch: '{goal}',
      cases: {
        'Fall asleep faster': 'falling asleep faster',
        'Stay asleep through the night': 'staying asleep through the night',
        'Improve sleep quality': 'improving sleep quality',
        'Wake up feeling refreshed': 'waking refreshed',
        'Feel more energized during the day': 'feeling more energized during the day',
        _default: 'improving sleep quality',
      },
    }),
  },
  {
    name: 'goal_phrase',
    expression: switchExpression({
      switch: '{goal}',
      cases: {
        'Fall asleep faster': 'fall asleep faster',
        'Stay asleep through the night': 'stay asleep all night',
        'Improve sleep quality': 'improve their sleep quality',
        'Wake up feeling refreshed': 'wake refreshed',
        'Feel more energized during the day': 'feel more energized during the day',
        _default: 'improve their sleep',
      },
    }),
  },
  {
    name: 'profile_goal_phrase',
    expression: switchExpression({
      switch: '{goal}',
      cases: {
        'Fall asleep faster': 'Fall asleep faster',
        'Stay asleep through the night': 'Stay asleep through the night',
        'Improve sleep quality': 'Improve sleep quality',
        'Wake up feeling refreshed': 'Wake up feeling refreshed',
        'Feel more energized during the day': 'Feel more energized during the day',
        _default: 'Improve sleep quality',
      },
    }),
  },
  {
    name: 'bedtime_midpoint_midnight_offset',
    expression: switchExpression({
      switch: '{bedtime_routines}',
      cases: {
        'Before 10 PM': '2.5',
        '10-11 PM': '1.5',
        '11 PM-12 AM': '0.5',
        '12-1 AM': '-0.5',
        'After 1 AM': '-1.5',
        Varied: '',
        _default: '',
      },
    }),
  },
  {
    name: 'wake_midpoint_midnight_offset',
    expression: switchExpression({
      switch: '{sleep_patterns}',
      cases: {
        'Before 6 AM': '5.5',
        '6-7 AM': '6.5',
        '7-8 AM': '7.5',
        '8-9 AM': '8.5',
        '9-10 AM': '9.5',
        'After 10 AM': '10',
        _default: '',
      },
    }),
  },
  {
    name: 'ideal_wake_midpoint_midnight_offset',
    expression: switchExpression({
      switch: '{sleep_consistency}',
      cases: {
        'Before 6 AM': '5.5',
        '6-7 AM': '6.5',
        '7-8 AM': '7.5',
        '8-9 AM': '8.5',
        '9-10 AM': '9.5',
        'After 10 AM': '10',
        _default: '',
      },
    }),
  },
];
